/**
 * Socket events. These are mapped to actions elsewhere.
 */

enum ChatEvent {
    Accept = "accept",
    Actions = "actions",
    AdministratorSignOut = "administrator_sign_out",
    ChatMessage = "chat_message",
    CustomerUrlChange = "customer_url_change",
    Disconnect = "disconnect",
    EndChat = "end_chat",
    ForceDisableChat = "force_disable_chat",
    ForceEnableChat = "force_enable_chat",
    ForceSignOut = "force_sign_out",
    Invite = "invite",
    InviteCancel = "invite_cancel",
    JoinAsObserver = "join_as_observer",
    LeaveAsObserver = "leave_as_observer",
    ProposedActivity = "proposed_activities",
    Reconnect = "reconnect",
    RefreshSid = "refresh_sid",
    Reject = "reject",
    SignIn = "sign_in",
    SignOut = "sign_out",
    SubscribeWebsiteSessionUpdates = "subscribe_website_session_updates",
    Transfer = "transfer",
    TransferFailure = "transfer_failure",
    TransferSuccess = "transfer_success",
    Typing = "typing",
    UserStateUpdate = "user_state_update",
    UnsubscribeWebsiteSessionUpdates = "unsubscribe_website_session_updates",
    WebsiteSessionUpdate = "website_session_update",
}

export default ChatEvent;
